import { render } from "./UserComment.vue?vue&type=template&id=27b5063e&scoped=true"
import script from "./UserComment.vue?vue&type=script&lang=js"
export * from "./UserComment.vue?vue&type=script&lang=js"

import "./UserComment.vue?vue&type=style&index=0&id=27b5063e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b5063e"]])

export default __exports__